import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9fdcd336&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9fdcd336&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdcd336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fdcd336')) {
      api.createRecord('9fdcd336', component.options)
    } else {
      api.reload('9fdcd336', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9fdcd336&scoped=true", function () {
      api.rerender('9fdcd336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubi/MainCont/index.vue"
export default component.exports